var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyToClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Billing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Unbilled-Orders",
    transform: "translate(-332.000000, -601.000000)",
    fill: "#137EC2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-1",
    transform: "translate(238.000000, 583.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-copy",
    transform: "translate(94.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 C0.895,0 0,0.895 0,2 L0,15 C0,15.552 0.448,16 1,16 C1.552,16 2,15.552 2,15 L2,2 L15,2 C15.552,2 16,1.552 16,1 C16,0.448 15.552,0 15,0 L2,0 Z M6,4 C4.895,4 4,4.895 4,6 L4,18 C4,19.105 4.895,20 6,20 L18,20 C19.105,20 20,19.105 20,18 L20,6 C20,4.895 19.105,4 18,4 L6,4 Z M6,6 L18,6 L18,18 L6,18 L6,6 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyToClipboard);
export default __webpack_public_path__ + "static/media/copyToClipboard.95b2be05759fa0ffdab4dcdc6b89c95c.svg";
export { ForwardRef as ReactComponent };